const $ = require('jquery');

export default {
  init() {
    const playButtons = document.querySelectorAll('.js-video-play');

    if (playButtons) {
      playButtons.forEach(playButton => {
        const video = $(`#${$(playButton).data('target-id')}`);

        $(playButton).on('click', () => {
          $(playButton)
            .closest('.video-block__overlay')
            .fadeOut();
          video[0].play();
        });

        video.on('ended', () => {
          $(playButton)
            .closest('.video-block__overlay')
            .fadeIn();
        });
      });
    }
  }
};
